/** Local / staging: allow buy & offer on own listings to test full flow. */
export function allowSelfDealForTest(): boolean {
  return (
    import.meta.env.DEV === true || String(import.meta.env.VITE_ALLOW_SELF_DEAL ?? '') === 'true'
  )
}

export function blocksOwnListingAction(ownerId: number, currentUserId?: number): boolean {
  if (currentUserId === undefined) return false
  if (ownerId !== currentUserId) return false
  return !allowSelfDealForTest()
}
